import React from 'react'
import NavBar from '../NavBar/NavBar'
import './Servises.css'
import { Link } from 'react-router-dom'
import home_device from '../../Image/home_devises.png'
import elc from '../../Image/elctrec.jpg'
import sepaka from '../../Image/sepaca.jpg'
import negara from '../../Image/nejara.jpeg'
import colder from '../../Image/colder.jpeg'
import nqash from '../../Image/neqasha.jpg'
import searameq from '../../Image/seramek.jpeg'
import tv from '../../Image/tv.jpeg'

function Servises() {
  return (
    <div className='servises' >
      <div className='servises_hedar' >
        <h1>خدمات صَيّن</h1>
      </div>
      <div className='servises_card' >
        <div className='card_2' >
          <div className='card_img' >
            <img src={home_device}  />
          </div>
          <div className='card_text' >
            <h2> أجهزة كهربائية </h2>
            <button><Link to='/فني'>اطلب الان</Link> </button>
          </div>
        </div>
        <div className='card_2' >
          <div className='card_img' >
            <img src={elc}  />
          </div>
          <div className='card_text' >
            <h2>كهرباء</h2>
            <button><Link to='/فني'>اطلب الان</Link> </button>
          </div>
        </div>
        <div className='card_2' >
          <div className='card_img' >
            <img src={sepaka}  />
          </div>
          <div className='card_text' >
            <h2>سباكه</h2>
            <button><Link to='/فني'>اطلب الان</Link> </button>
          </div>
        </div>
        <div className='card_2' >
          <div className='card_img' >
            <img src={negara}  />
          </div>
          <div className='card_text' >
            <h2> نجاره والموتال</h2>
            <button><Link to='/فني'>اطلب الان</Link> </button>
          </div>
        </div>
        <div className='card_2' >
          <div className='card_img' >
            <img src={colder}  />
          </div>
          <div className='card_text' >
            <h2>تكييفات</h2>
            <button><Link to='/فني'>اطلب الان</Link> </button>
          </div>
        </div>
        <div className='card_2' >
          <div className='card_img' >
            <img src={nqash}  />
          </div>
          <div className='card_text' >
            <h2>نقاشه و محاره</h2>
            <button><Link to='/فني'>اطلب الان</Link> </button>
          </div>
        </div>
        <div className='card_2' >
          <div className='card_img' >
            <img src={searameq}  />
          </div>
          <div className='card_text' >
            <h2> سيراميك و رخام </h2>
            <button><Link to='/فني'>اطلب الان</Link> </button>
          </div>
        </div>
        <div className='card_2' >
          <div className='card_img' >
            <img src={tv}  />
          </div>
          <div className='card_text' >
            <h2>شاشه و دش</h2>
            <button><Link to='/فني'>اطلب الان</Link> </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Servises
